export const CONFIRMED_CREATE_PRESCRIPTION_ACTION =
  "CONFIRMED_CREATE_PRESCRIPTION_ACTION";
export const CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION =
  "CONFIRMED_GET_SUGGESTED_PRESCRIPTION_ACTION";
export const UPDATE_DURATION_REQUEST = "UPDATE_DURATION_REQUEST";
export const UPDATE_DURATION_SUCCESS = "UPDATE_DURATION_SUCCESS";
export const UPDATE_DURATION_FAILURE = "UPDATE_DURATION_FAILURE";
export const CONFIRMED_GET_PATIENT_PRESCRIPTIONS =
  "CONFIRMED_GET_PATIENT_PRESCRIPTIONS";
export const CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION =
  "CONFIRMED_GET_PATIENT_PRESCRIPTIONS_ACTION";
export const HOLD_PATIENT_MEDICINE = "HOLD_PATIENT_MEDICINE"
export const HOLD_PATIENT_MEDICINE_SUCCESS = "HOLD_PATIENT_MEDICINE_SUCCESS"
export const HOLD_PATIENT_MEDICINE_FAIL = "HOLD_PATIENT_MEDICINE_FAIL"

export const STOP_PATIENT_PRESCRIPTION_REQUEST =
  "STOP_PATIENT_PRESCRIPTION_REQUEST";

export const STOP_PATIENT_PRESCRIPTION_SUCCESS =
  "STOP_PATIENT_PRESCRIPTION_SUCCESS";

export const STOP_PATIENT_PRESCRIPTION_FAIL =
  "STOP_PATIENT_PRESCRIPTION_FAIL";

export const UPDATE_PRESCRIPTION_REQUEST = "UPDATE_PRESCRIPTION_REQUEST";
export const UPDATE_PRESCRIPTION_SUCCESS = "UPDATE_PRESCRIPTION_SUCCESS";
export const UPDATE_PRESCRIPTION_FAIL = "UPDATE_PRESCRIPTION_FAIL";